import { useEffect } from "react"

interface EventListener<E extends Event = Event> {
  (event: E): void
}

interface HookProps<C extends EventListener> {
  callback: C,
  types: string[],
  target?: Element | Document | Window,
  options?: AddEventListenerOptions
}

export const useEventEffect = <C extends EventListener>({
  target, 
  callback, 
  types, 
  options,
}: HookProps<C>) => useEffect(() => {
  const effectTarget = target ?? window
  types.forEach(type => effectTarget.addEventListener(type, callback, options))
  return () => void types.forEach(type => effectTarget.removeEventListener(type, callback, options))
})
